enum TemplateGalacticHeaderConst {
  DEFAULT = 'base',
  PICTURE_DROP_MENU = 'pictureDropMenu',
}

export default TemplateGalacticHeaderConst;
